/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// import * as WebBrowser from 'expo-web-browser';
import React, { useContext, useState } from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { useTheme } from '../../../../providers/theme';
import { ChipV } from '../../../../widgets/ChipV';
import 'react-responsive-modal/styles.css';
import { ImageModal } from '../../../../widgets/ImageModal';
import { PdfViewerModal } from '../../../../widgets/PdfViewerModal';

export interface IChipList {
  chipItems: any[];
  staticData?: any;
}

export const ChipList = ({ chipItems, staticData }: IChipList) => {
  const [loading, setLoading] = useState<boolean>(false);
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [Chip, setChip] = useState<object>({});

  const onCloseModal = () => setOpen(false);
  // console.log('check chip items ==> ', chipItems);

  const _onChipPress = async (item: any) => {
    if (item?.docUri) {
      setChip(item);

      setOpen(true);
    }
  };

  if (loading) {
    return <ActivityIndicator size='large' color={theme?.colors?.primary} />;
  }

  const _renderChips = () => {
    if (chipItems && Array.isArray(chipItems) && chipItems.length > 0) {
      console.log(`staticData :`, staticData);
      return chipItems.map((element) => {
        if (element?.docUri)
          return {
            ...element,
            rightIconName: staticData?.rightIconName,
            rightIconType: staticData?.rightIconType,
            rightIconColor: 'grey',
            rightIconSize: staticData?.rightIconSize,
          };
        return element;
      });
    }
  };
  console.log(`Chip :: `, Chip);
  if (Chip?.docUri && Chip?.docUri.split('.').pop() == 'pdf') {
    // It is a pdf
    console.log(`Chip itss PDF :: `, Chip);
  }
  return (
    <View style={StyleSheet.flatten([styles.container])}>
      <ChipV
        chipItems={_renderChips()}
        onChipItemPress={_onChipPress}
        // chipBorderWidth={0.5}
        // chipBorderColor={theme?.palette?.primary}
      />
      {/* <Modal
                open={open}
                onClose={onCloseModal}
                center
                style={{ width: ScreenWidth * 0.9 }}
            > */}
      <View style={{ marginTop: 30, marginBottom: 5 }}>
        {/* <PDFScreen pdfFile={uri} height={ScreenHeight * 0.7} /> */}
        {Chip?.docUri && Chip?.docUri.split('.').pop() == 'pdf' ? (
          <PdfViewerModal
            file={Chip?.docUri}
            showModal={open}
            onPdfClose={onCloseModal}
          />
        ) : (
          <ImageModal
            imageSrc={Chip?.docUri}
            showModal={open}
            onDeny={onCloseModal}
          />
        )}

        {/* {Chip?.type === "pdf" ? (
                    <PdfViewerModal
                        file={Chip?.docUri}
                        showModal={open}
                        onPdfClose={onCloseModal}
                    />
                ) : Chip?.type === "image" ? (
                    <ImageModal
                        imageSrc={Chip?.docUri}
                        showModal={open}
                        onDeny={onCloseModal}
                    />
                ) : (
                    <div />
                )} */}
      </View>
      {/* </Modal> */}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginLeft: 5,
  },
});

ChipList.defaultProps = {
  //chipItems: BP.chipItems,
} as Partial<IChipList>;
